import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

const AUTH_IMG = "/images/auth-bg.png";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left image */}
      <div className="hidden lg:block relative">
        <img src={AUTH_IMG} alt="Sposa" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60" />
        <div className="absolute top-8 left-8 right-8">
          <Link to="/" className="flex items-center gap-2.5 text-white" data-testid="auth-home-link">
            <BrandLogo size={32} />
            <span className="font-serif-heading text-xl tracking-tight">AI Bridal Manager™</span>
          </Link>
        </div>
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="font-serif-heading text-4xl leading-tight italic">
            "Ogni sposa merita un'organizzazione impeccabile."
          </p>
          <p className="mt-4 text-sm text-white/80 uppercase tracking-[0.2em]">— Il nostro impegno</p>
        </div>
      </div>

      {/* Right content */}
      <div className="flex flex-col justify-center p-8 sm:p-12 lg:p-16 bg-background relative">
        <div className="lg:hidden mb-8">
          <Link to="/" className="flex items-center gap-2.5">
            <BrandLogo size={32} />
            <span className="font-serif-heading text-xl">AI Bridal Manager™</span>
          </Link>
        </div>
        <div className="max-w-md w-full mx-auto">
          <span className="label-uppercase">{subtitle}</span>
          <h1 className="font-serif-heading text-4xl sm:text-5xl tracking-tight mt-3">{title}</h1>
          <div className="mt-10">{children}</div>
          {footer && <div className="mt-8 text-sm text-neutral-600">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
